export default "<ngx-stripe-payment></ngx-stripe-payment>\n<router-outlet></router-outlet>\n\n<!-- <h1>hello</h1> -->"